import DateRange from 'moment-range';

const doRangesOverlap = (from1, to1, from2, to2) =>
  new DateRange(from1, to1).overlaps(new DateRange(from2, to2));

export default doRangesOverlap;
